// RentersInsuranceFAQ.ts
// ----------------------------------------------------------------------------
// 10 Frequently Asked Questions for Renters Insurance
// Fields: id, question, answer, category, type
// ----------------------------------------------------------------------------

export interface RentersInsuranceFAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
  type: string;
}


export const rentersInsuranceFAQs: RentersInsuranceFAQ[] = [
  {
    id: 1,
    question: "What is renters insurance?",
    answer:
      "Renters insurance is a policy that provides financial protection for your personal belongings against risks like fire, theft, or certain types of water damage. It also includes liability coverage and sometimes additional living expenses.",
    category: "Basics",
    type: "General",
  },
  {
    id: 2,
    question: "Does my landlord’s insurance cover my belongings?",
    answer:
      "No. Your landlord’s policy typically covers only the building structure, not your personal property. Renters insurance is necessary to protect your belongings.",
    category: "Coverage",
    type: "Misconceptions",
  },
  {
    id: 3,
    question: "How much renters insurance do I need?",
    answer:
      "The amount depends on the value of your belongings. A good approach is to take inventory of your personal property and choose coverage limits that would allow you to replace your items if they were lost or damaged.",
    category: "Coverage",
    type: "Financial",
  },
  {
    id: 4,
    question: "What does renters insurance usually cover?",
    answer:
      "It typically covers personal property, personal liability, medical payments to others, and additional living expenses if you’re displaced due to a covered loss.",
    category: "Coverage",
    type: "Policy",
  },
  {
    id: 5,
    question: "What is not covered by renters insurance?",
    answer:
      "Most policies do not cover damage from floods, earthquakes, or routine wear and tear. Separate policies or endorsements may be needed for those risks.",
    category: "Coverage",
    type: "Exclusions",
  },
  {
    id: 6,
    question: "How much does renters insurance cost?",
    answer:
      "Renters insurance is generally affordable, averaging $15–$30 per month depending on coverage limits, deductible, and location.",
    category: "Cost",
    type: "Financial",
  },
  {
    id: 7,
    question: "Is renters insurance required by law?",
    answer:
      "No. It is not legally required, but many landlords require tenants to carry renters insurance as part of the lease agreement.",
    category: "Requirements",
    type: "Legal",
  },
  {
    id: 8,
    question: "Does renters insurance cover roommates?",
    answer:
      "No. Policies usually cover only the named insured and their immediate family members. Roommates need their own separate renters insurance policies.",
    category: "Coverage",
    type: "Special Cases",
  },
  {
    id: 9,
    question: "How do I file a renters insurance claim?",
    answer:
      "Contact your insurance company as soon as possible, provide documentation (photos, receipts, police reports if applicable), and follow their claims process for reimbursement.",
    category: "Claims",
    type: "Process",
  },
  {
    id: 10,
    question: "Does renters insurance cover items outside my home?",
    answer:
      "Yes. Most policies cover personal property both inside and outside your residence — for example, if your laptop is stolen from your car or while traveling.",
    category: "Coverage",
    type: "General",
  },
  {
    id: 11,
    question: "What is liability coverage in renters insurance?",
    answer:
      "Liability coverage protects you financially if someone is injured in your rental unit or if you accidentally damage someone else’s property. It can also help cover legal expenses.",
    category: "Coverage",
    type: "Policy",
  },
  {
    id: 12,
    question: "Can I bundle renters insurance with auto insurance?",
    answer:
      "Yes. Many insurance companies offer discounts if you bundle renters insurance with auto or other policies, lowering your overall premiums.",
    category: "Savings",
    type: "Financial",
  },
  {
    id: 13,
    question: "Does renters insurance cover natural disasters?",
    answer:
      "Standard renters insurance usually covers fire, windstorms, and hail, but not floods or earthquakes. You may need a separate policy for those specific risks.",
    category: "Coverage",
    type: "Exclusions",
  },
  {
    id: 14,
    question: "How do deductibles work in renters insurance?",
    answer:
      "A deductible is the amount you pay out of pocket before your insurance kicks in. For example, if you have a $500 deductible and file a $2,000 claim, you pay $500 and the insurer pays $1,500.",
    category: "Cost",
    type: "Financial",
  },
  {
    id: 15,
    question: "Will renters insurance cover temporary housing costs?",
    answer:
      "Yes. If your rental becomes uninhabitable due to a covered loss, renters insurance typically pays for additional living expenses such as hotel stays or meals.",
    category: "Coverage",
    type: "Policy",
  },
  {
    id: 16,
    question: "Do students living in dorms need renters insurance?",
    answer:
      "Yes. While some students may be covered under their parents’ homeowners insurance, many need their own renters insurance to protect personal belongings and liability.",
    category: "Coverage",
    type: "Special Cases",
  },
  {
    id: 17,
    question: "Does renters insurance cover pets or pet damage?",
    answer:
      "Liability coverage may protect you if your pet injures someone, but most policies do not cover damage caused by pets to your own property or the rental unit.",
    category: "Coverage",
    type: "Special Cases",
  },
  {
    id: 18,
    question: "How can I lower the cost of my renters insurance?",
    answer:
      "You can reduce premiums by bundling with other policies, increasing your deductible, maintaining good credit, or installing safety features like smoke detectors and security systems.",
    category: "Cost",
    type: "Savings",
  },
  {
    id: 19,
    question: "Can I get renters insurance if I have bad credit?",
    answer:
      "Yes, but insurers may charge higher premiums. Shopping around can help you find a more affordable policy despite a lower credit score.",
    category: "Eligibility",
    type: "Financial",
  },
  {
    id: 20,
    question: "How do I choose the best renters insurance policy?",
    answer:
      "Compare coverage options, limits, exclusions, deductibles, and customer service reviews. Look for a balance between affordability and comprehensive protection.",
    category: "Selection",
    type: "General",
  },
];



// export const rentersInsuranceFAQs: RentersInsuranceFAQ[] = [
//   {
//     id: 1,
//     question: "What is renters insurance?",
//     answer:
//       "Renters insurance is a policy that provides financial protection for your personal belongings against risks like fire, theft, or certain types of water damage. It also includes liability coverage and sometimes additional living expenses.",
//     category: "Basics",
//     type: "General",
//   },
//   {
//     id: 2,
//     question: "Does my landlord’s insurance cover my belongings?",
//     answer:
//       "No. Your landlord’s policy typically covers only the building structure, not your personal property. Renters insurance is necessary to protect your belongings.",
//     category: "Coverage",
//     type: "Misconceptions",
//   },
//   {
//     id: 3,
//     question: "How much renters insurance do I need?",
//     answer:
//       "The amount depends on the value of your belongings. A good approach is to take inventory of your personal property and choose coverage limits that would allow you to replace your items if they were lost or damaged.",
//     category: "Coverage",
//     type: "Financial",
//   },
//   {
//     id: 4,
//     question: "What does renters insurance usually cover?",
//     answer:
//       "It typically covers personal property, personal liability, medical payments to others, and additional living expenses if you’re displaced due to a covered loss.",
//     category: "Coverage",
//     type: "Policy",
//   },
//   {
//     id: 5,
//     question: "What is not covered by renters insurance?",
//     answer:
//       "Most policies do not cover damage from floods, earthquakes, or routine wear and tear. Separate policies or endorsements may be needed for those risks.",
//     category: "Coverage",
//     type: "Exclusions",
//   },
//   {
//     id: 6,
//     question: "How much does renters insurance cost?",
//     answer:
//       "Renters insurance is generally affordable, averaging $15–$30 per month depending on coverage limits, deductible, and location.",
//     category: "Cost",
//     type: "Financial",
//   },
//   {
//     id: 7,
//     question: "Is renters insurance required by law?",
//     answer:
//       "No. It is not legally required, but many landlords require tenants to carry renters insurance as part of the lease agreement.",
//     category: "Requirements",
//     type: "Legal",
//   },
//   {
//     id: 8,
//     question: "Does renters insurance cover roommates?",
//     answer:
//       "No. Policies usually cover only the named insured and their immediate family members. Roommates need their own separate renters insurance policies.",
//     category: "Coverage",
//     type: "Special Cases",
//   },
//   {
//     id: 9,
//     question: "How do I file a renters insurance claim?",
//     answer:
//       "Contact your insurance company as soon as possible, provide documentation (photos, receipts, police reports if applicable), and follow their claims process for reimbursement.",
//     category: "Claims",
//     type: "Process",
//   },
//   {
//     id: 10,
//     question: "Does renters insurance cover items outside my home?",
//     answer:
//       "Yes. Most policies cover personal property both inside and outside your residence — for example, if your laptop is stolen from your car or while traveling.",
//     category: "Coverage",
//     type: "General",
//   },
// ];
